import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__doc" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "footer__vizex" }
const _hoisted_8 = ["innerHTML"]

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import useDocumentLinks from '@/composition/useDocumentLinks';
import dayjs from '@/utils/dayjs';
import { currentCopyright, currentSupportLink } from '@/utils';
import SystemRequirementsModal from '@/components/SystemRequirmentsModal.vue';
import TelegramButton from '@/components/TelegramButton.vue';
import { names } from '@/constants/routes';


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();

const contentClass = computed(
  () => (route.name === names.laboratory ? 'container' : 'container-flex')
);

const isModalOpen = ref(false);
const date = dayjs().format('YYYY');
const documents = useDocumentLinks();
// const showPdfLink = process.env.VUE_APP_TYPE !== 'international';
const showPdfLink = !['international', 'ksa'].includes(process.env.VUE_APP_TYPE || 'default');
const telegramBotName = process.env.VUE_APP_TELEGRAM_BOT;

const handleModalToggle = (flag: boolean) => {
  isModalOpen.value = flag;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["footer__content", contentClass.value])
    }, [
      _createElementVNode("div", _hoisted_2, [
        showPdfLink
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(documents).licenseAgreement,
              target: "_blank",
              class: "footer__link"
            }, _toDisplayString(_unref(t)("footer.licenseAgreement")), 9, _hoisted_3))
          : _createCommentVNode("", true),
        showPdfLink
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _unref(documents).termsOfUse,
              target: "_blank",
              class: "footer__link"
            }, _toDisplayString(_unref(t)("footer.termsOfUse")), 9, _hoisted_4))
          : _createCommentVNode("", true),
        (_unref(currentSupportLink))
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              target: "_blank",
              class: "footer__link",
              href: _unref(currentSupportLink)
            }, _toDisplayString(_unref(t)("footer.support")), 9, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "footer__link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleModalToggle(true)))
        }, _toDisplayString(_unref(t)("systemRequirements.systemRequirements")), 1),
        showPdfLink
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: _unref(documents).personalDataProcessingRules,
              target: "_blank",
              class: "footer__link"
            }, _toDisplayString(_unref(t)("footer.personalDataProcessingRules")), 9, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_unref(telegramBotName))
          ? (_openBlock(), _createBlock(TelegramButton, {
              key: 0,
              username: _unref(telegramBotName)
            }, null, 8, ["username"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "footer__copyright",
          innerHTML: _unref(currentCopyright)(_unref(t), _unref(date))
        }, null, 8, _hoisted_8)
      ]),
      _createVNode(SystemRequirementsModal, {
        isOpen: isModalOpen.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (handleModalToggle($event)))
      }, null, 8, ["isOpen"])
    ], 2)
  ]))
}
}

})